import Vue from 'vue'
import Router from 'vue-router'
import HomePage from './components/HomePage.vue'

import AdverseEventsChart from './components/AdverseEventsChart'
import AsrTimeline from './components/AsrTimeline.vue'
import BreastImplantsChart from './components/BreastImplantsChart'
import BreastImplantsStackedChart from './components/BreastImplantsStackedChart'
import BreastImplantWarnings from './components/BreastImplantWarnings'
import CompanyInjuriesDeaths from './components/CompanyInjuriesDeaths'
import DeathsUnderreporting from './components/DeathsUnderreporting'
import DeviceRelatedIncidentsInEurope from './components/DeviceRelatedIncidentsInEurope'
import DoctorPaymentsChart from './components/DoctorPaymentsChart'
import HealthcareIndustryChart from './components/HealthcareIndustryChart'
import IndustryTimeline from './components/IndustryTimeline.vue'
import LobbyingChart from './components/LobbyingChart'
import MedtronicDoctorPayments from './components/MedtronicDoctorPayments'
import MedtronicLobbyingChart from './components/MedtronicLobbyingChart'
import PmaWaitTimes from './components/PmaWaitTimes'
import NorwegianReports from './components/NorwegianReports'
import ReportsProblemsInvolvingMedicalDevicesInUK from './components/ReportsProblemsInvolvingMedicalDevicesInUK'
import SynchromedTimeline from './components/SynchromedTimeline.vue'
import TaviTimeline from './components/TaviTimeline.vue'

import { EmbeddableFooter } from '@icij/murmur'
import { ImddbHeader } from '@icij/murmur'
import { GenericFooter } from '@icij/murmur'

Vue.use(Router)

const embeddableProps = {
  default: (route) => {
    return  {
      noHeading: !!route.query["no-heading"],
      noDeck: !!route.query["no-deck"],
      socialMode: !!route.query["social-mode"],
      noEmbeddableFooter: !!route.query["no-embeddable-footer"],
      chartHeightRatio: Number(route.query["chart-height-ratio"])
    }
  }
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home-page',
      components: {
        default: HomePage,
        header: ImddbHeader,
        footer: GenericFooter
      }
    },
    {
      path: '/adverse-events',
      name: 'adverse-events-chart',
      props: embeddableProps,
      components: {
        default: AdverseEventsChart,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/asr-timeline',
      name: 'asr-timeline',
      props: embeddableProps,
      components: {
        default: AsrTimeline,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/breast-implants',
      name: 'breast-implants-chart',
      props: embeddableProps,
      components: {
        default: BreastImplantsChart,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/breast-implants-stacked-chart',
      name: 'breast-implants-stacked-chart',
      props: embeddableProps,
      components: {
        default: BreastImplantsStackedChart,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/breast-implant-warnings',
      name: 'breast-implant-warnings',
      props: embeddableProps,
      components: {
        default: BreastImplantWarnings,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/company-adverse-events',
      name: 'company-adverse-events',
      props: embeddableProps,
      components: {
        default: CompanyInjuriesDeaths,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/deaths-underreporting',
      name: 'deaths-underreporting',
      props: embeddableProps,
      components: {
        default: DeathsUnderreporting,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/device-related-incidents-in-europe',
      name: 'device-related-incidents-in-europe',
      props: {
        default: (route) => {
          return {
            ...embeddableProps.default(route),
            defaultCountry: route.query['country']
          }
        }
      },
      components: {
        default: DeviceRelatedIncidentsInEurope,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/reports-of-problems-involving-medical-devices-since-2008-in-uk',
      name: 'reports-of-problems-involving-medical-devices-since-2008-in-uk',
      props: embeddableProps,
      components: {
        default: ReportsProblemsInvolvingMedicalDevicesInUK,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/norwegian-reports',
      name: 'norwegian-reports',
      props: embeddableProps,
      components: {
        default: NorwegianReports,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/doctor-payments',
      name: 'doctor-payments-chart',
      props: embeddableProps,
      components: {
        default: DoctorPaymentsChart,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/healthcare-industry-chart',
      name: 'healthcare-industry-chart',
      props: embeddableProps,
      components: {
        default: HealthcareIndustryChart,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/industry-lobbying',
      name: 'lobbying-chart',
      props: embeddableProps,
      components: {
        default: LobbyingChart,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/medtronic-doctor-payments',
      name: 'medtronic-doctor-payments',
      props: embeddableProps,
      components: {
        default: MedtronicDoctorPayments,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/medtronic-lobbying',
      name: 'medtronic-lobbying',
      props: embeddableProps,
      components: {
        default: MedtronicLobbyingChart,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/overview',
      name: 'investigation-overview',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
        default: () => import(/* webpackChunkName: "overview" */ './components/InvestigationOverview.vue'),
        // default: HomePage,
        header: ImddbHeader,
        footer: GenericFooter
      }
    },
    {
      path: '/pma-wait-times',
      name: 'pma-wait-times',
      props: embeddableProps,
      components: {
        default: PmaWaitTimes,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/synchromed-timeline',
      name: 'synchromed-timeline',
      props: embeddableProps,
      components: {
        default: SynchromedTimeline,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/tavi-timeline',
      name: 'tavi-timeline',
      props: embeddableProps,
      components: {
        default: TaviTimeline,
        footer: EmbeddableFooter
      }
    },
    {
      path: '/timeline',
      name: 'industry-timeline',
      props: embeddableProps,
      components: {
        default: IndustryTimeline,
        footer: EmbeddableFooter
      }
    },
  ]
})
